import { DetailedReplicationHubAccess } from "./DetailedReplicationHubAccess.js";

export interface ReplicationHubAccessResult {
    results: DetailedReplicationHubAccess[];
}